import React, { PropsWithChildren } from 'react';
import classnames from 'classnames';
import styles from './SGSButton.module.scss';
import { LinearProgress } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

type Props = {
    color?: 'primary' | 'secondary' | 'tertiary' | 'dark' | 'light' | 'export';
    className?: string;
    disabled?: boolean;
    variant?: 'contained' | 'outlined';
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    // size?: string;
    type?: 'button' | 'submit' | 'reset';
    icon?: string;
    loading?: boolean;
    id?: string;
};

const SGSButton: React.FC<PropsWithChildren<Props>> = ({
    color = 'primary',
    type = 'button',
    disabled = false,
    className,
    children,
    variant = 'contained',
    // size,
    icon,
    loading,
    id,
    ...props
}) => {
    const { t } = useTranslation();
    return (
        <button
            id={id}
            disabled={loading || disabled}
            type={type}
            // disabled={disabled}
            {...props}
            className={classnames(
                styles.btn,
                styles[`btn__${variant}`],
                styles[`btn__${variant}__${color}`],
                // size === 'large' && styles.btn__large,
                className,
            )}
        >
            {!loading && icon && <i className={classnames(icon, 'mr-2')} />}
            {!loading && children}
            {loading && t('global.pleaseWait')}
            {loading && <LinearProgress />}
        </button>
    );
};

export default SGSButton;
